require('./retailLoanPersonalData.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const { isEmpty } = require('lodash/lang');
const classNames = require('classnames');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
// @components
const RetailLoanPersonalDataModal = require('../../../contractRetailLoan/retailLoanStepTwo/retailLoanPersonalData/retailLoanPersonalDataModal');
const RetailLoanAddress = require('../../../contractRetailLoan/retailLoanAddress/retailLoanAddress');
// @ constants
const {
    retailLoanDoTaggin: {
        NAME_PAGE_WIZARD_VIEW,
        TAGGING_LOAD_NEW_ADDRESS,
        TAGGING_LOAD_BILLING_ADDRESS,
    },
} = require('../../../../../loansConstants/index');
//@helpers
const { buildEventsModal } = require('../../../../../loansUtilities/loansHelper');
// @ utilities
const {
    recordLinkV2,
} = require('utilities/tagging');

class RetailLoanPersonalData extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModalEditAddres: false,
            showModalCreateAddres: false,
            showModalDeliveryAddress: false,
        };
    }

    handleToggleModal(prop, typeModal, tagEvent) {
        if (typeModal && tagEvent) {
            const customData = buildEventsModal(typeModal, tagEvent, NAME_PAGE_WIZARD_VIEW);
            recordLinkV2(customData);
        }

        this.setState({
            [prop]: !this.state[prop]
        });
    }

    buildBillingData(personalDataValues, showModalDescription, isSecondAddress = false) {
        const { immProfileFields, changeBillingAddress } = this.props;

        const typeValue = !!isSecondAddress ? "otherAddress" : "personalData";
        const classNameBox = classNames('retail-loan-personal-data__content-personal-data', {
            'retail-loan-personal-data__content-personal-data--active': personalDataValues.get('isSelected')
        });

        return (
            <RetailLoanAddress
                className={classNameBox}
                classNameItem="retail-loan-personal-data__value-address"
                classNameWithoutBold="retail-loan-personal-data__title-address"
                mobileText="contractRetailLoanStepTwo-contractRetailLoanStepTwo_mobileNumber"
                immProfile={immProfileFields}
                immAddress={personalDataValues}
                onHandleOpenEditModal={() => this.handleToggleModal(showModalDescription)}
                changeBillingAddress={() => changeBillingAddress(typeValue)}
                isSecondAddress={isSecondAddress}
            />
        );
    }

    buildSectionFirstAddres(personalDataValues, typeAddress) {
        const { immRetailLoan, updatePersonalData, immProfileFields } = this.props;
        const { showModalEditAddres } = this.state;
        const billingData = this.buildBillingData(personalDataValues, typeAddress);

        return (
            <React.Fragment>
                {billingData}
                {!isEmpty(personalDataValues.get('typeOfRoads')) &&
                    <RetailLoanPersonalDataModal
                        updatePersonalData={updatePersonalData}
                        immRetailLoan={immRetailLoan}
                        immProfileFields={immProfileFields}
                        showModal={showModalEditAddres}
                        onHandleToggleModal={(tagModal, typeEvent) => this.handleToggleModal(typeAddress, tagModal, typeEvent)}
                        propEdit="personalData"
                        tagModal={TAGGING_LOAD_NEW_ADDRESS}
                    />
                }
            </React.Fragment>
        );
    }

    buildSectionAddOtherAddres(updatePersonalData, typeAddress) {
        const { immRetailLoan, immProfileFields } = this.props;
        const { showModalCreateAddres } = this.state;
        let billingData = this.buildBillingData(immRetailLoan.get("otherAddress"), typeAddress, true);

        return (
            <React.Fragment>
                <RetailLoanPersonalDataModal
                    updatePersonalData={updatePersonalData}
                    immRetailLoan={immRetailLoan}
                    immProfileFields={immProfileFields}
                    showModal={showModalCreateAddres}
                    onHandleToggleModal={(tagModal, typeEvent) => this.handleToggleModal(typeAddress, tagModal, typeEvent)}
                    propEdit="otherAddress"
                    tagModal={TAGGING_LOAD_NEW_ADDRESS}
                />
                {billingData}
            </React.Fragment>
        );
    }


    buildOtherAddressInformation(personalDataValues, showModalDescription) {
        const { immRetailLoan, immProfileFields } = this.props;
        const classNameBox = classNames('retail-loan-personal-data__content-personal-data', {
            'retail-loan-personal-data__content-personal-data--error': immRetailLoan.get('billingAddressError')
        });

        return (
            <RetailLoanAddress
                className={classNameBox}
                classNameItem="retail-loan-personal-data__value-address"
                classNameWithoutBold="retail-loan-personal-data__title-address"
                mobileText="contractRetailLoanStepTwo-contractRetailLoanStepTwo_mobileNumber"
                immProfile={immProfileFields}
                immAddress={personalDataValues}
                onHandleOpenEditModal={() => this.handleToggleModal(showModalDescription)}
                changeBillingAddress={() => this.handleToggleModal(showModalDescription)}
                isThirdAddress
            />
        );
    }

    buildOtherBillingAddress(updatePersonalData, typeAddress) {
        const { immRetailLoan, immProfileFields, changeDeliveryAddressValue } = this.props;
        const { showModalDeliveryAdress } = this.state;
        const otherBillingAddressIsSelected = immRetailLoan.get('otherBillingAddressIsSelected');
        const billingData = !otherBillingAddressIsSelected ? this.buildOtherAddressInformation(immRetailLoan.get("billingAddress"), typeAddress) : null;

        return (
            <React.Fragment>
                <OKCheckbox
                    idName="contract-retail-loan-step-two-billing-address"
                    label={formatText('contractRetailLoanStepTwo-contractRetailLoanStepTwo_sameAddressToShipping')}
                    onChange={changeDeliveryAddressValue}
                    value={otherBillingAddressIsSelected}
                />
                {billingData}
                <RetailLoanPersonalDataModal
                    updatePersonalData={updatePersonalData}
                    immRetailLoan={immRetailLoan}
                    immProfileFields={immProfileFields}
                    showModal={showModalDeliveryAdress}
                    onHandleToggleModal={(tagModal, typeEvent) => this.handleToggleModal(typeAddress, tagModal, typeEvent)}
                    propEdit="billingAddress"
                    tagModal={TAGGING_LOAD_BILLING_ADDRESS}
                />
            </React.Fragment>
        );
    }

    buildSectionBillingData() {
        const { immRetailLoan, isAddressType, updatePersonalData } = this.props;
        const personalDataValues = immRetailLoan.get("personalData");

        const firstAddress = this.buildSectionFirstAddres(personalDataValues, "showModalEditAddres");
        const otherAddress = this.buildSectionAddOtherAddres(updatePersonalData, "showModalCreateAddres");
        const billingAddress = isAddressType ? this.buildOtherBillingAddress(updatePersonalData, "showModalDeliveryAdress") : null;
        const title = isAddressType ? "contractRetailLoanStepTwo-deliveryAddress" : "contractRetailLoanStepTwo-contractRetailLoanStepTwo_titleDeliveryDataBilling";

        return (
            <React.Fragment>
                <FormattedText
                    value={title}
                    className="retail-loan-personal-data__billing-sub-title"
                />
                <div className="row">
                    <div className="col-xs-6">{firstAddress}</div>
                    <div className="col-xs-6">{otherAddress}</div>
                </div>

                <div className="col-md-6 retail-loan-personal-data__content-billing-address">
                    <FormattedText
                        value="contractRetailLoanStepTwo-contractRetailLoanStepTwo_otherDeliveryAddress"
                        className="retail-loan-personal-data__billing-sub-title"
                    />
                    {billingAddress}
                </div>
            </React.Fragment>
        );
    }

    buildTitles() {
        return (
            <div>
                <FormattedText
                    value="contractRetailLoanStepTwo-contractRetailLoanStepTwo_BuyDataBilling"
                    className="retail-loan-personal-data__billing-title"
                />
            </div>
        );
    }

    render() {
        const { isAddressType } = this.props;

        const AllComponentsBillingData = this.buildSectionBillingData();
        const titles = !isAddressType ? this.buildTitles() : null;
        return (
            <div className="col-md-12">
                {titles}
                {AllComponentsBillingData}
            </div>
        );
    }

}

RetailLoanPersonalData.propTypes = {
    changeBillingAddress: PropTypes.func.isRequired,
    changeDeliveryAddressValue: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    isAddressType: PropTypes.bool,
    personalData: PropTypes.object.isRequired,
    updatePersonalData: PropTypes.func.isRequired,
};

module.exports = RetailLoanPersonalData;
